import React from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import styles from './successMessage.module.css';
import DoctorIcon from './images/doctor.svg';

export const SuccessMessage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.contentWrapper}>
        <img src={DoctorIcon} alt="doctor" className={styles.icon} />
        <h2 className={styles.mainTitle}>{t('get_in_touch.title.success_message_1')}</h2>
        <h3 className={styles.subTitle}>{t('get_in_touch.title.success_message_2')}</h3>
      </div>
    </div>
  );
};
